import { useEffect, useState } from "react";

import Modal from "react-modal/lib/components/Modal";
import closeImg from "../../assets/close.png";
import "./style.css";
import { set } from "date-fns";

function ModalMain({
	ident,
	children,
	overlayClassName = "react-modal-overlay",
	className = "react-modal-content",
	onClose,
}) {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const handleOpen = () => {
			setIsOpen((prevState) => !prevState); //abre o modal
		};
		window.addEventListener(ident, handleOpen);
		return () => {
			window.removeEventListener(ident, handleOpen);
		};
	}, []);

	const handleCloseModalRegister = () => {
		if (onClose) {
			onClose();
		}
		setIsOpen(false);
	};

	return (
		<>
			<Modal
				isOpen={isOpen}
				onRequestClose={handleCloseModalRegister}
				overlayClassName={overlayClassName}
				className={className}
				// className="react-modal-content "
				// overlayClassName="react-modal-Main-overlay"
				// className="modal-main-content-form modal-main-resize"
				shouldCloseOnOverlayClick={false}
			>
				<div className="flex flex-col container-forms">
					<button
						type="button"
						// onClick={openModalFilterSupplier}
						className="react-modal-close"
						onClick={(e) => handleCloseModalRegister()}
					>
						<img src={closeImg} alt="" />
					</button>

					{children}
				</div>
			</Modal>
		</>
	);
}

export default ModalMain;
